var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 7 6",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43817 3.63444C4.57671 3.46934 4.82286 3.4478 4.98796 3.58634L6.59852 4.93776C6.76362 5.0763 6.78515 5.32244 6.64662 5.48755C6.50808 5.65265 6.26193 5.67418 6.09683 5.53565L4.48627 4.18423C4.32117 4.04569 4.29964 3.79954 4.43817 3.63444Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1266 1.0488C2.31581 1.0488 1.65854 1.70607 1.65854 2.51686C1.65854 3.32765 2.31581 3.98492 3.1266 3.98492C3.93739 3.98492 4.59466 3.32765 4.59466 2.51686C4.59466 1.70607 3.93739 1.0488 3.1266 1.0488ZM0.878052 2.51686C0.878052 1.27502 1.88476 0.268311 3.1266 0.268311C4.36844 0.268311 5.37515 1.27502 5.37515 2.51686C5.37515 3.7587 4.36844 4.76541 3.1266 4.76541C1.88476 4.76541 0.878052 3.7587 0.878052 2.51686Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.1f2491276b669a0089d49116f579ca64.svg";
export { ForwardRef as ReactComponent };